/* eslint no-inline-comments: 0 */

const List = () => import( /* webpackChunkName: "group-tags" */ `./list.vue` );
const Add = () => import( /* webpackChunkName: "group-tags" */ `./add.vue` );
const Import = () => import( /* webpackChunkName: "group-tags" */ `./import.vue` );
const Edit = () => import( /* webpackChunkName: "group-tags" */ `./edit.vue` );

const TermSuggestionDetail = () => import( /* webpackChunkName: "group-tags" */ `./term-suggestion-detail.vue` );

const Settings = () => import( /* webpackChunkName: "group-tags" */ `./settings.vue` );

export default {
	path: `tags`,
	children: [
		{
			path: ``,
			name: `list-tags`,
			component: List,
			meta: {
				title: `Tags`
			}
		},
		{
			path: `new`,
			name: `add-tag`,
			component: Add,
			meta: {
				title: `Add Tag`
			}
		},
		{
			path: `import`,
			name: `import-tags`,
			component: Import,
			meta: {
				title: `Import Tags`
			}
		},
		// Retired into the unified Requests page: term suggestions are listed
		// there and decided one at a time on the page below. The old list URL
		// still lands on Requests, filtered to term suggestions.
		{
			path: `suggestions`,
			name: `term-suggestions`,
			redirect: {
				name: `requests`,
				query: {
					type: `term_suggestion`
				}
			}
		},
		{
			// No nav entry of its own: reached from a term suggestion's row on
			// the Requests page.
			path: `suggestions/:uuid`,
			name: `term-suggestion-detail`,
			component: TermSuggestionDetail,
			meta: {
				title: `Term Suggestion`
			}
		},
		{
			path: `:uuid`,
			name: `edit-tag`,
			component: Edit,
			meta: {
				title: `Edit Tag`
			}
		},
		{
			path: `settings`,
			name: `tag-settings`,
			component: Settings,
			meta: {
				title: `Tag Settings`
			}
		}
	]
};
